<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary d-print-none">
                        <div class="page-header-content">
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-10 col-xl-8">
                                    <div class="single-post">
                                        <router-link to="/resource-visits" class="d-print-none"><i class="fas fa-arrow-left"></i> Back</router-link>
                                        <h1>Visit Planner for Ulcerative Colitis</h1>
                                        <p class="lead">The Visit Planner for Ulcerative Colitis is a very simple tool to help you prepare for a visit with your care team. Complete the fields below, then print a copy to take with you. 
                                        </p> 
                                        <div class="d-flex align-items-center justify-content-between mb-5 d-print-none">
                                            <div class="single-post-meta mr-4">
                                                <div class="single-post-meta-details">
                                                    <div class="single-post-meta-details-name"><i class="fas fa-tag"></i> Visits</div>
                                                    <div class="single-post-meta-details-date">Feb 5 &#xB7; 6 min read</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <form>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">During the past month, treatment of Ulcerative Colitis has been a worry in my/my child's life: </label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios1" value="option1" >
                                                        <label class="form-check-label" for="gridRadios1">
                                                            All of the time 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2" value="option2">
                                                        <label class="form-check-label" for="gridRadios2">
                                                            Most of the time 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios3" value="option3">
                                                        <label class="form-check-label" for="gridRadios3">
                                                            Some of the time 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios4" value="option4">
                                                        <label class="form-check-label" for="gridRadios4">
                                                            A little of the time 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios5" value="option5">
                                                        <label class="form-check-label" for="gridRadios5">
                                                            None of the time 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">I understand the nature and causes of my/my child’s Ulcerative Colitis: </label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios2" id="gridRadios11" value="option11" >
                                                        <label class="form-check-label" for="gridRadios11">
                                                            Strongly disagree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios2" id="gridRadios21" value="option21">
                                                        <label class="form-check-label" for="gridRadios21">
                                                            Disagree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios2" id="gridRadios31" value="option31">
                                                        <label class="form-check-label" for="gridRadios31">
                                                            Neither agree nor disagree  
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios2" id="gridRadios41" value="option41">
                                                        <label class="form-check-label" for="gridRadios41">
                                                            Agree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios2" id="gridRadios51" value="option51">
                                                        <label class="form-check-label" for="gridRadios51">
                                                            Strongly Agree  
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">I know the different treatment options available for my/my child’s Ulcerative Colitis: </label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios3" id="gridRadios12" value="option12" >
                                                        <label class="form-check-label" for="gridRadios12">
                                                            Strongly disagree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios3" id="gridRadios22" value="option22">
                                                        <label class="form-check-label" for="gridRadios22">
                                                            Disagree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios3" id="gridRadios32" value="option32">
                                                        <label class="form-check-label" for="gridRadios32">
                                                            Neither agree nor disagree  
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios3" id="gridRadios42" value="option42">
                                                        <label class="form-check-label" for="gridRadios42">
                                                            Agree 
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios3" id="gridRadios52" value="option52">
                                                        <label class="form-check-label" for="gridRadios52">
                                                            Strongly Agree  
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group">
                                                    <label class="text-dark" for="inputMessage">Here is my list of things I'm concerned about and questions that I have: </label>
                                                    <textarea class="form-control" id="inputMessage" type="text" placeholder="Enter your concerns..." rows="7" spellcheck="false"></textarea>
                                                    <small>Note: If printing from this page, make sure all text in this box is visible before clicking the link to print.</small>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">Since your last visit, have you/your child been in the emergency room or been hospitalized forUlcerative Colitis?: </label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios4" id="gridRadios13" value="option13" >
                                                        <label class="form-check-label" for="gridRadios13">
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios4" id="gridRadios23" value="option23">
                                                        <label class="form-check-label" for="gridRadios23">
                                                           No 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">If you answered "yes" to the question above, when was it?: </label>
                                                    <input class="form-control" id="inputName" type="text" placeholder="MM/DD/YYYY">
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">Since your last visit, have you/your child had a relapse (a return of your Ulcerative Colitis symptoms)?: </label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios5" id="gridRadios14" value="option14" >
                                                        <label class="form-check-label" for="gridRadios14">
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="gridRadios5" id="gridRadios24" value="option24">
                                                        <label class="form-check-label" for="gridRadios24">
                                                           No 
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label class="text-dark">If you answered "yes" to the question above, when was it?: </label>
                                                    <input class="form-control" id="inputName" type="text" placeholder="MM/DD/YYYY">
                                                </div>
                                            </div>
                                               
                                            <div class="text-right d-print-none"><button class="btn btn-primary btn-marketing rounded-pill" type="submit" onclick="window.print()">Print</button></div>
                                        </form>
                                        
                                        <div class="text-center d-print-none"><router-link class="btn btn-transparent-dark btn-marketing rounded-pill" to="/resource-list">Back to Resources</router-link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark d-print-none">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

<script>
import $ from 'jquery';
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  }
}
// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);



</script>
